<p-dialog [(visible)]="visible"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [header]="'Force Assign Request'"
          (onHide)="onDialogHide()"
          [position]="'right'"
          [appendTo]="'body'"
          [style]="{width: '522px', transform: 'translateX(-44px)'}">
    <hr class="driver-line" style="margin-left: -1rem; margin-right: -1rem;" />

    <div style="margin: 10px 0;">Nearby Drivers</div>

    <div *ngFor="let rider of riders" class="flex-row" style="margin-bottom: 3px;">
        <!-- Avatar -->
        <div *ngIf="!rider.ImageUrl" class="lm-assign-rider-avatar-empty">
            {{rider.FirstName | slice:0:1 | uppercase}}{{rider.LastName | slice:0:1 | uppercase}}
        </div>
        <div *ngIf="rider.ImageUrl">
            <img class="lm-assign-rider-avatar" src="{{rider.ImageUrl}}" />
        </div>

        <div style="padding: 2px 0 0 10px;">
            <div>{{rider.FirstName}} {{rider.LastName}}</div>
            <div>{{rider.DistanceInKm}}km away</div>
        </div>

        <div class="filler"></div>
        
        <div style="padding-top: 2px">
            <button pButton type="button" label="Assign"
                    (click)="onAssignRider(rider.Id)"></button>
        </div>
    </div>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<spinner *ngIf="isSpinnerVisible" style="position: fixed; top: 50vh; right: 170px; z-index: 10001"></spinner>

<p-toast position="top-right"></p-toast>
